import { z } from 'zod';

/**
 * What `POST /me/billing/sync` did: how many purchases the store held that the
 * ledger lacked, now applied. The client re-reads the case or the entitlement
 * on any answer — the count is for the member's own "did it work?", never a
 * substitute for the read (N14).
 */
export const BillingSyncResultSchema = z
  .object({
    applied: z.number().int().nonnegative(),
  })
  .strict();

export type BillingSyncResult = z.infer<typeof BillingSyncResultSchema>;
